import React from 'react';
import {Image} from 'react-native';

export default function Conversation({ width, height } : SvgProps) {
  return <Image style={{ width, height }} source={require('./undraw_conversation_re_c26v.svg')} />
};

